import Core from '@mediaplatform/sportal365-football-sdk-v2';
import { ILineupsApi, ILineupsResponseData } from '../types';

export default (sdk: Core): ILineupsApi => {
  const getLineups: ILineupsApi['getLineups'] = ({ signal, dataMatchId, dataGroupPlayersByCategories }) => {
    if (dataMatchId) {
      const lineups = sdk.lineups({ matchId: dataMatchId });

      if (!lineups) {
        return;
      }

      if (dataGroupPlayersByCategories) {
        lineups.groupPlayersByCategories();
      }

      return lineups.get({ signal }) as Promise<ILineupsResponseData>;
    }

    console.warn('You must provide a valid match id.');
  };

  return { getLineups };
};
